import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import { BacklogApiError } from "./BacklogApiError";
import type { BacklogApiErrorDetailList } from "./BacklogApiErrorDetailList";

export class BacklogApiTooManyRequestsError extends BacklogApiError {
	constructor(options: {
		response: BacklogHttpResponse;
		error_details: BacklogApiErrorDetailList;
	}) {
		super({
			response: options.response,
			error_details: options.error_details,
			message: "BacklogApiTooManyRequestsError",
		});
	}
}
